import { select } from 'redux-saga/effects';
import { getCustomer } from '@app/redux/customer/selectors';
import { TrackPayloadDecorators } from '../types';

/**
 * Properties that should be sent to every GA event, pageview, etc.
 */
export function* buildGlobalDecorators(decorators: TrackPayloadDecorators) {
  const newDecorators = {
    ...decorators,
  };

  if (!newDecorators.customer) {
    const customer = yield select(getCustomer);
    if (customer) {
      newDecorators.customer = customer;
    }
  }

  return newDecorators;
}
